"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DocumentIcon_svg_1 = __importDefault(require("../../assets/images/DocumentIcon.svg"));

var Spinner_svg_1 = __importDefault(require("../../assets/images/Spinner.svg"));

exports.fileAssets = {
  documentTile: {
    icon: DocumentIcon_svg_1.default,
    spinner: Spinner_svg_1.default
  }
};